import { hexToRgba } from "../../utils/hexToRgba";
export function TextChip({ text, color: propColor }) {
  let color = propColor;
  if (color === "success") {
    color = "#619834";
  }
  if (color === "error") {
    color = "#e02200";
  }

  if (color === "warning") {
    color = "#FF6F31";
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: hexToRgba(color, 0.1),
        color: hexToRgba(color, 1),
        borderRadius: "5px",
        padding: "3px 10px",
        // whiteSpace: "nowrap",
        fontSize: "12px",
        width: "100%",
        minWidth: "80px",
        borderColor: hexToRgba(color, 1),
        fontWeight: "500",
      }}
    >
      {text}
    </div>
  );
}
